angular.module("vgresiduos").controller("SupplierViewCollectionRequestEquipmentEditCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `fornecedor/gestao-solicitacoes/equipamento/${$stateParams.id}`);
		};
	}
]);
